import { useMeQuery } from 'core/graphql';

interface IPendingSurveysCount {
  count: number;
  activeRole: string | null;
  userId: string | null;
}

/**
 * Reads `me.pendingSurveysCount` (spec 0011) — the nag banner/modal ride on
 * the cached `me` query, no dedicated count query. Mirrors useLmsAccessBlock:
 * `cache-and-network` so a survey attached (or submitted elsewhere) mid-session
 * surfaces on the next mount without a hard reload. The backend returns null
 * for non-students — normalized to 0 here.
 */
export const usePendingSurveysCount = (): IPendingSurveysCount => {
  const { data } = useMeQuery({ fetchPolicy: 'cache-and-network' });

  return {
    count: data?.me?.pendingSurveysCount ?? 0,
    activeRole: data?.me?.activeRole ?? null,
    userId: data?.me?.id ?? null,
  };
};
